import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import videojs from 'video.js';

@Component({
  selector: 'app-video-player',
  templateUrl: './video-player.component.html',
  styleUrls: ['./video-player.component.scss']
})
export class VideoPlayerComponent implements OnInit, OnDestroy {


  @Input() url: string;
  player: any;
  constructor() { }

  ngOnInit(): void {
    // console.log("play")

    if(this.url.endsWith('.m3u8')){
      this.player = videojs('my-video', {
        sources: [{
          src: this.url,
          type: 'application/x-mpegURL'
        }],
        autoplay: true,
        controls: true
      });
    }
    else if (this.url.endsWith('.mp4')){
      this.player = videojs('my-video', {
        sources: [{
          src: this.url,
          type: 'video/mp4'
        }],
        autoplay: true,
        controls: true
      });
    }

  }

  ngOnDestroy(): void {
    if (this.player) {
      this.player.dispose();
      this.player = null;
    }
  }

}
